// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"5a3ab51f","703":"0d42c8f3","787":"4f429171"}[chunkId] + ".chunk.js";
};